/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_File_Type_ErrorInputs */

const en_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only PDF and DOCX files are supported`)
};

const de_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur PDF- und DOCX-Dateien werden unterstützt`)
};

const fr_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les fichiers PDF et DOCX sont pris en charge`)
};

const es_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se admiten archivos PDF y DOCX`)
};

const it_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono supportati solo file PDF e DOCX`)
};

const nl_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen PDF- en DOCX-bestanden worden ondersteund`)
};

const pl_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwane są tylko pliki PDF i DOCX`)
};

const fi_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain PDF- ja DOCX-tiedostot ovat tuettuja`)
};

const da_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun PDF- og DOCX-filer understøttes`)
};

const sv_resumes_file_type_error = /** @type {(inputs: Resumes_File_Type_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bara PDF- och DOCX-filer stöds`)
};

/**
* | output |
* | --- |
* | "Only PDF and DOCX files are supported" |
*
* @param {Resumes_File_Type_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_file_type_error = /** @type {((inputs?: Resumes_File_Type_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_File_Type_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_file_type_error(inputs)
	if (locale === "fr") return fr_resumes_file_type_error(inputs)
	if (locale === "es") return es_resumes_file_type_error(inputs)
	if (locale === "it") return it_resumes_file_type_error(inputs)
	if (locale === "nl") return nl_resumes_file_type_error(inputs)
	if (locale === "pl") return pl_resumes_file_type_error(inputs)
	if (locale === "fi") return fi_resumes_file_type_error(inputs)
	if (locale === "da") return da_resumes_file_type_error(inputs)
	if (locale === "sv") return sv_resumes_file_type_error(inputs)
	return en_resumes_file_type_error(inputs)
});